<template>
  <!-- ✅ body로 보내서 팝업 위로 무조건 뜨게 -->
  <teleport to="body">
    <!-- ALERT -->
    <div v-if="alertMsg" class="app-modal-overlay" @click.self="closeAlert">
      <div class="app-modal" role="dialog" aria-modal="true">
        <div class="app-modal-message">{{ alertMsg }}</div>
        <div class="app-modal-actions alert-actions">
          <button class="app-btn primary" @click="closeAlert">확인</button>
        </div>
      </div>
    </div>
    <!-- CONFIRM -->
    <div v-if="confirmState.open" class="app-modal-overlay" @click.self="resolveConfirm(false)">
      <div class="app-modal" role="dialog" aria-modal="true">
        <div class="app-modal-message">{{ confirmState.message }}</div>
        <div class="app-modal-actions">
          <button class="app-btn secondary" @click="resolveConfirm(false)">
            {{ confirmState.cancelText }}
          </button>
          <button class="app-btn primary" @click="resolveConfirm(true)">
            {{ confirmState.okText }}
          </button>
        </div>
      </div>
    </div>
  </teleport>
</template>
<script setup>
    import { watch }        from 'vue'
    import { useRouter }    from 'vue-router'
    import { useAppAlert }  from '@/composables/useAppAlert'

    const router = useRouter()

    const {
        alertMsg,
        pendingRoutePath,
        closeAlert,
        confirmState,
        resolveConfirm,
    } = useAppAlert()

    // ✅ showAlertAndMove()로 세팅된 경우, alert 닫을 때 이동
    watch(alertMsg, (v, prev) => {
        // prev가 있고 지금이 ''로 바뀌면(닫힘) 이동
        if (prev && !v && pendingRoutePath.value) {
            const path = pendingRoutePath.value
            pendingRoutePath.value = ''
            router.push(path)
        }
    })
</script>

